import * as React from 'react'

const SvgPersonOrangeBgIcon = (props) => (
  <svg
    width="56"
    height="57"
    viewBox="0 0 56 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_4413_93597)">
      <rect x="12" y="0.775391" width="32" height="32" rx="8" fill="#FF692E" />
      <path
        d="M31.9999 19.3333C32.9705 19.8209 33.8026 20.6034 34.4101 21.5818C34.5303 21.7756 34.5905 21.8725 34.6113 22.0066C34.6535 22.2792 34.4671 22.6144 34.2132 22.7223C34.0882 22.7754 33.9477 22.7754 33.6666 22.7754M30.6666 16.4636C31.6544 15.9727 32.3332 14.9533 32.3332 13.7754C32.3332 12.5975 31.6544 11.5781 30.6666 11.0872M29.3332 13.7754C29.3332 15.4322 27.9901 16.7754 26.3332 16.7754C24.6764 16.7754 23.3332 15.4322 23.3332 13.7754C23.3332 12.1185 24.6764 10.7754 26.3332 10.7754C27.9901 10.7754 29.3332 12.1185 29.3332 13.7754ZM21.706 21.401C22.7689 19.8051 24.4461 18.7754 26.3332 18.7754C28.2203 18.7754 29.8975 19.8051 30.9604 21.401C31.1932 21.7506 31.3097 21.9254 31.2963 22.1487C31.2858 22.3225 31.1719 22.5354 31.0329 22.6405C30.8545 22.7754 30.6091 22.7754 30.1183 22.7754H22.5481C22.0573 22.7754 21.8119 22.7754 21.6335 22.6405C21.4946 22.5354 21.3806 22.3225 21.3702 22.1487C21.3568 21.9254 21.4732 21.7506 21.706 21.401Z"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_4413_93597"
        x="0"
        y="0.775391"
        width="56"
        height="56"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="12"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_4413_93597"
        />
        <feOffset dy="12" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.411765 0 0 0 0 0.180392 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4413_93597"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4413_93597"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export default SvgPersonOrangeBgIcon
